<div class="dsm-flex-container hero">
    <div class="flex-row">
        <picture class="mx-auto">
            <source media="(max-width: {{viewSizeMobile}}px)"
                    srcset="{{mobileImagePath}}">
            <source srcset="{{desktopImagePath}}">
            <img class="img-fluid mx-auto"
                 src="{{desktopImagePath}}" alt=""/>
        </picture>

        <div class="hero-content {{textStyle}} {{contentAlignment}} ">
            <div>
                <h1 class="heading-2">{{translationRoot+'.title' | translate:useLocaleOverride}}</h1>
                <button *ngIf="componentData.includeCallToAction" type="button" class="button button-large {{buttonType}}" (click)="callToActionClick()">
                    {{translationRoot +'.button' | translate:useLocaleOverride}}
                </button>
            </div>
        </div>
    </div>
</div>
